import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class requerimientoProduccionService { 
    
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorEstado(filter) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/listar-por-estado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    
    async listarEstado() {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }


    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/requerimiento-produccion/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/requerimiento-produccion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/requerimiento-produccion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/requerimiento-produccion/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    /******* TRANSACCIONES ******/
}

export default new requerimientoProduccionService();